import { serviceV2 } from '@/utils/request'

const prefix = '/talent-recommendation'

export default {
  getRecommendationList (jobId, params) {
    return serviceV2.get(`${prefix}/job/${jobId}/`, { params })
  },
  createRecommendation (data) {
    return serviceV2.post(`${prefix}/`, data)
  },
  getRecommendationCreateTask (taskId) {
    return serviceV2.get(`${prefix}/`, { params: { task_id: taskId } })
  },
  createRecommendMoreTask (recommendationId) {
    return serviceV2.post(`${prefix}/${recommendationId}/recommend-more/`)
  },
  createRetryRecommendTask (recommendationId, loadTaskId) {
    return serviceV2.post(`${prefix}/${recommendationId}/recommend-more/`, { is_retry: true, load_task_id: loadTaskId })
  },
  getRecommendMoreTask (recommendationId, taskId) {
    return serviceV2.get(`${prefix}/${recommendationId}/recommend-more/`, { params: { task_id: taskId } })
  },
  getRecommendedTalentList (recommendationId, params) {
    return serviceV2.get(`${prefix}/${recommendationId}/recommended-talent/`, { params })
  },
  batchUpdateRecommendedTalent (recommendationId, data) {
    return serviceV2.put(`${prefix}/${recommendationId}/recommended-talent/`, data)
  },
  updateRecommendedTalentViewed (recommendationId, candidateId) {
    return serviceV2.post(`${prefix}/${recommendationId}/recommended-talent/${candidateId}/viewed/`)
  }
}
